import { __extends } from "tslib";
import React from 'react';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { moveGallectionToPosition, } from '../../actions';
import GallectionGrid from '../GallectionGrid';
import PopupInnerLayout from '../../_partials/PopupInnerLayout';
import FolderCard from '../../_partials/FolderCard';
import { isGallectionManageable, isFeaturedGallection } from '../../helpers';
import LoadingIndicator from '../../../LoadingIndicator';
import NumberedItemWrapper from '../../_partials/NumberedItemWrapper';
import GallectionControlButtons from '../../_partials/GallectionControlButtons';
import AddGallectionButton from '../../_partials/AddGallectionButton';
import withGallections from '../../_hocs/withGallections';
import withCurrentMediaSource from '../../_hocs/withCurrentMediaSource';
import FeaturedGallectionControlButtons from '../../_partials/FeaturedGallectionControlButtons';
import { GallectionType } from '../../../types/gallection';
import { MediaSourceType } from '../../types';
import { MeasuredCookieType } from '../../../Measured';
import gallectionManagerStyles from './GallectionManager.scss';
var enhance = compose(withGallections, withCurrentMediaSource, connectMediaStore(null, { moveGallectionToPosition: moveGallectionToPosition }), withTranslation());
var GallectionManager = /** @class */ (function (_super) {
    __extends(GallectionManager, _super);
    function GallectionManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fetchMoreGallectionsIfNeeded = function () {
            var _a = _this.props, hasMoreGallections = _a.hasMoreGallections, isFetchingGallections = _a.isFetchingGallections, fetchMoreGallections = _a.fetchMoreGallections;
            if (!hasMoreGallections || isFetchingGallections) {
                return;
            }
            fetchMoreGallections();
        };
        _this.renderGallection = function (_a) {
            var index = _a.index, width = _a.width;
            var gallections = _this.props.gallections;
            var gallection = gallections[index];
            var extras = undefined;
            if (isGallectionManageable(gallection)) {
                extras = (React.createElement(GallectionControlButtons, { gallection: gallection, existingGallectionNames: _this.existingGallectionNames, className: gallectionManagerStyles['folder-card-controls'], moreMenuClassName: gallectionManagerStyles['folder-card-controls-menu'] }));
            }
            else if (
            // Right now, we only have gallery specific controls on the featured gallery
            // so we're avoiding showing this for collections
            isFeaturedGallection(gallection) &&
                gallection.type === GallectionType.GALLERY) {
                extras = (React.createElement(FeaturedGallectionControlButtons, { gallection: gallection, className: gallectionManagerStyles['folder-card-controls'] }));
            }
            return (React.createElement(NumberedItemWrapper, { number: index + 1 },
                React.createElement(FolderCard, { className: gallectionManagerStyles['folder-card'], width: width, folder: gallection, isLocked: !isGallectionManageable(gallection), extras: extras, withPremiumShownNextToTitle: true, withPrice: true })));
        };
        return _this;
    }
    GallectionManager.prototype.render = function () {
        return (React.createElement(PopupInnerLayout, { headerSubtitle: this.getSubtitle(), headerExtrasRightZone: React.createElement(AddGallectionButton, null), scrollableContent: this.renderContent(), onScrolledToBottom: this.fetchMoreGallectionsIfNeeded, onNotScrollable: this.fetchMoreGallectionsIfNeeded }));
    };
    GallectionManager.prototype.getSubtitle = function () {
        var _a = this.props, t = _a.t, currentMediaSource = _a.currentMediaSource;
        switch (currentMediaSource) {
            case MediaSourceType.STASH:
                return t('mediapopup.editYourStashFoldersHint');
            case MediaSourceType.GALLERY:
                return t('mediapopup.editYourGalleriesHint');
            case MediaSourceType.COLLECTION:
            default:
                return t('mediapopup.editYourCollectionsHint');
        }
    };
    GallectionManager.prototype.renderContent = function () {
        var _a = this.props, isGallectionStreamInitialized = _a.isGallectionStreamInitialized, gallections = _a.gallections, hasMoreGallections = _a.hasMoreGallections, moveGallection = _a.moveGallectionToPosition;
        this.existingGallectionNames = this.props.gallections.map(function (gallection) { return gallection.name; });
        return (React.createElement(React.Fragment, null,
            isGallectionStreamInitialized && (React.createElement(GallectionGrid, { cookieType: MeasuredCookieType.GALLECTION_MANAGER, gallections: gallections, gallectionRenderer: this.renderGallection, moveGallectionToPosition: moveGallection })),
            hasMoreGallections && (React.createElement(LoadingIndicator, { view: "daSymbol", coverMode: !gallections.length && hasMoreGallections }))));
    };
    return GallectionManager;
}(React.Component));
export { GallectionManager };
export default enhance(GallectionManager);
//# sourceMappingURL=GallectionManager.connected.js.map